import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ReactMarkdown from 'react-markdown';

export default function TermsOfServicePage() {
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/terms-of-service.md')
      .then(res => res.text())
      .then(text => {
        setContent(text);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen" style={{
      background: 'linear-gradient(135deg, #EFF6FF 0%, #ECFDF5 100%)'
    }}>
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <button
            onClick={() => navigate(-1)}
            className="btn-3d h-12 w-12 rounded-xl flex items-center justify-center bg-white border-2 border-slate-200 hover:border-blue-300"
          >
            <ArrowLeft size={20} className="text-slate-600" />
          </button>
          <h1 className="text-3xl font-bold gradient-text">Terms of Service</h1>
        </div>

        {/* Content */}
        <div className="card-3d p-6 md:p-10">
          {loading ? (
            <div className="text-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
            </div>
          ) : (
            <div className="prose prose-slate max-w-none prose-headings:text-slate-900 prose-p:text-slate-600 prose-li:text-slate-600 prose-strong:text-slate-700">
              <ReactMarkdown>{content}</ReactMarkdown>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="text-center mt-8 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} GuestCheckoutapp. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}
